<template>
  <div class="marketplace vs-con-loading__container">
    <TopNavBar :filters.sync="filters" />
    <div class="marketplace__content">
      <div class="vx-row">
        <!-- filter menu -->
        <div class="vx-col w-full lg:w-1/5 md:w-1/3 sm:w-1/3">
          <FilterMenu :filters.sync="filters" />
        </div>

        <!-- product list -->
        <div class="vx-col w-full lg:w-3/5 md:w-2/3 sm:w-2/3 px-5 mb-10">
          <!-- advertise slider -->
          <ImageSlider class="mt-5" :options="{ perPage: 1, autoplay: true, paginationEnabled: true, navigationEnabled: true, loop: true }" :slides="adsImages" />

          <!-- product list options -->
          <div class="products__display_options mt-8 text-right">
            <div class="btn-group">
              <vs-button color="success" @click="product_view = 'list'">List View</vs-button>
              <vs-button color="danger" @click="product_view = 'grid'">Grid View</vs-button>
            </div>
          </div>

          <!-- product list -->
          <div class="products__list">
            <ProductListView v-if="product_view == 'list'" :products="marketplace_products" />
            <ProductGridView v-if="product_view == 'grid'" :products="marketplace_products" />

            <!-- pagination -->
            <vs-pagination v-if="marketplace_products.length" :total="totalPages" :max="7" v-model="page" class="mt-8"></vs-pagination>
          </div>
        </div>
        <div class="vx-col hidden lg:w-1/5 lg-block"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import TopNavBar from '@/views/marketplace/components/TopNavbar.vue'
import FilterMenu from '@/views/marketplace/components/FilterMenu.vue'
import ImageSlider from '@/views/marketplace/components/ImageSlider.vue'
import ProductListView from '@/views/marketplace/components/ProductListView.vue'
import ProductGridView from '@/views/marketplace/components/ProductGridView.vue'
import Image1 from '@/assets/images/banners/image1.png'
import Image2 from '@/assets/images/banners/image2.png'

export default {
  name: 'MarketPlace',
  components: {
    TopNavBar,
    FilterMenu,
    ImageSlider,
    ProductListView,
    ProductGridView
  },

  data() {
    return {
      adsImages: [
        {
          image: Image1
        },
        {
          image: Image2
        }
      ],
      product_view: 'grid',

      page: 1,
      limit: 10,

      filters: {
        sellerId: null,
        search: '',
        verifiedSeller: [],
        isFilterApplied: false,
        categoryId: [],
        cityId: null,
        weightType: null,
        cbd: null,
        thc: null,
        terpenoidPotency: null,
        roomType: [],
        plantStage: [],
        growMethod: []
      },

      marketplace_products: []
    }
  },

  async mounted() {
    try {
      const tempFilter = JSON.parse(localStorage.getItem('marketplace_filters'))
      if (tempFilter) {
        this.filters = {
          ...this.filters,
          ...tempFilter
        }
      }
    } catch (e) {}

    if (this.$route.name === 'marketlist-view-sellerProducts' && this.$route.params.id) {
      this.filters.sellerId = this.$route.params.id
    }

    // fetch the market place products
    await this.get_marketPlaceProducts()
  },

  computed: {
    ...mapState('marketplace', ['loading', 'total', 'filteredCount']),

    // set total pages for pagination
    totalPages() {
      return Math.ceil(this.filteredCount / this.limit)
    },

    // set max pages for pagination
    maxPages() {
      return this.totalPages / this.filters.limit > 7 ? 7 : this.totalPages / this.limit
    }
  },

  methods: {
    ...mapActions('marketplace', { get_marketplace_products: 'get_market_place_products' }),

    // get all market place products
    async get_marketPlaceProducts() {
      try {
        const payload = {
          ...this.filters,
          verifiedSeller: (this.filters.verifiedSeller || []).length === 2 ? null : (this.filters.verifiedSeller || [])[0],
          page: this.page,
          limit: this.limit
        }

        const res = await this.get_marketplace_products(payload)
        this.marketplace_products = res.data
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // check filter applied
    isFilterApplied() {
      return Object.keys(this.filters).reduce((acc, key) => {
        if (!['sellerId', 'isFilterApplied'].includes(key)) {
          if (![null, ''].includes(this.filters[key]) && this.filters[key] && this.filters[key].length !== 0) {
            acc = true
          }
        }

        return acc
      }, false)
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '.marketplace .products__list',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('.marketplace .products__list > .con-vs-loading')
      }
    },

    $route: {
      handler() {
        if (this.$route.params.id) {
          this.filters.sellerId = this.$route.params.id
        } else {
          this.filters.sellerId = null
        }
      },
      deep: true,
      immediate: true
    },

    // fetch products
    filters: {
      async handler() {
        this.filters.isFilterApplied = !!(await this.isFilterApplied())

        if (this.filters.isFilterApplied) {
          this.page = 1
        }

        if (this.$route.name !== 'marketlist-view-sellerProducts') {
          localStorage.setItem('marketplace_filters', JSON.stringify(this.filters))
        }

        await this.get_marketPlaceProducts()
      },
      deep: true
    },

    page: {
      async handler() {
        await this.get_marketPlaceProducts()
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    if (_.path.search('marketplace') === -1) {
      this.filters.isFilterApplied = false
      this.filters.search = ''
      this.filters.verifiedSeller = []
      this.filters.categoryId = []
      this.filters.weightType = null
      this.filters.cityId = null
      this.filters.cbd = null
      this.filters.thc = null
      this.filters.terpenoidPotency = null
      this.filters.roomType = []
      this.filters.plantStage = []
      this.filters.growMethod = []
    }

    this.page = 1
    next()
  }
}
</script>

<style></style>
